<script>
    export let control;
    export let assessment;

    import Fa from "svelte-fa";
    import {faLink} from "@fortawesome/free-solid-svg-icons";
</script>

{#if assessment.assessment_type_data.question_tags}
    {#each assessment.assessment_type_data.question_tags as tag}
        <div
            class="button is-{tag.color_class} is-rounded"
            class:is-light={!assessment.model.getTag(control.id, tag.tag_id).value}
            on:click={() => assessment.model.setTag(control.id, tag.tag_id, 1)}
        >
            {tag.name}
            {#if control.tag_mapping[tag.tag_id]}
                &nbsp;<Fa icon={faLink} />
            {/if}
        </div>
    {/each}
{/if}

{#each assessment.question_tags.tags as tag}
    <div
        class="button is-link is-rounded is-{tag.color_class} is-{tag.color_class}"
        class:is-light={!assessment.model.getTag(control.id, tag.id).value}
        on:click={() => assessment.model.setTag(control.id, tag.id, 1)}
    >
        {tag.name}
    </div>
{/each}

<style>
    .button.is-rounded {
        border-radius: 290486px !important; /* I have no idea why this number is used, but it's what is used in bulma */
    }
</style>